/**
 * Csv Schema of MotoristaMensagemPush
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {MotoristaMensagemPush} from '@/model/resource/MotoristaMensagemPush'

/* TODO: review generated schema */
export class CsvMotoristaMensagemPushSchema extends Schema {
  readonly name = 'CsvMotoristaMensagemPush'

  readonly fieldSet: FieldSet<MotoristaMensagemPush> = {
    idMensagemPk: schema => schema.model.idMensagemPk,
    motorista: schema => schema.model.motorista?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    mensagem: schema => schema.model.mensagem,
    data: schema => Helper.datetime(schema.model.data),
    ativo: schema => Helper.bool(schema.model.ativo),
    lida: schema => Helper.bool(schema.model.lida),
  }
}
